// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import AxiosPlugin from './plugins/AxiosPlugin'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import VueLocalStorage from 'vue-localstorage'
import _ from 'lodash'
import acl from './router/acl'
import VeeValidate from 'vee-validate'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.use(BootstrapVue)
Vue.use(AxiosPlugin)
Vue.use(VModal)
Vue.use(Notifications)
Vue.use(VueLocalStorage)
Vue.use(VeeValidate, {
  inject: false,
  locale: 'pt_BR',
  fieldsBagName: 'validationFields',
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  acl,
  template: '<App/>',
  components: {
    App,
  },

  data() {
    return {
      url: '',
    };
  },

  computed: {
    permissions() {
      return this.usuario('perfis');
    },
    isUser() {
      return !!_.filter(this.permissions, { perfil_id: 1 }).length;
    },
    isGestor() {
      return !!_.filter(this.permissions, { perfil_id: 2 }).length;
    },
    isAdmin() {
      return !!_.filter(this.permissions, { perfil_id: 3 }).length;
    },
  },

  mounted() {
    this.$events.$on('refresh-token', this.refreshToken);

    this.url = process.env.NODE_ENV === 'production'
    ? 'https://time-sheet.meta.com.br/api'
    : 'https://time-sheet.meta.com.br/api';

    this.$events.$on('loading', (value) => {
      const display = value ? 'flex' : 'none';
      document.getElementById('loading').style.display = display;
    });

    setInterval(this.validarToken, 60000);
  },

  methods: {
    async refreshToken() {
      try {
        const token = await this.$http.post('/refresh_token');
        const currentToken = JSON.parse(this.$localStorage.get('user'));

        currentToken.access_token = token.data.access_token;
        this.$localStorage.set('user', JSON.stringify(currentToken));
      } catch(e) {
        console.log(e);
      }
    },

    usuario(index = null) {
      const token = this.$localStorage.get('user');
      const usuario = token ? JSON.parse(token) : {};

      return index ? usuario[index] : usuario;
    },

    validarToken() {
      try {
        this.$http.get('/validar-token');
      } catch(e) {
        return false;
      }
    },
  },
})
